import {useState} from "react"
import {fetchData} from "../util/Server"
import Endpoints from "../util/Endpoints"
import {ERROR, Notify} from "../util/Notify"

const useRefunds = ({status, businessId, page = 1, limit = 25} = {}) => {
    const [isLoading, setIsLoading] = useState(false)
    const [rows, setRows] = useState([])
    const [totalRows, setTotalRows] = useState(0)
    const [totalPages, setTotalPages] = useState(0)

    const loadRefunds = () => {
        setIsLoading(true)

        const params = new URLSearchParams()
        if (status) params.append("status", status)
        if (businessId) params.append("business_id", businessId)
        params.append("page", page)
        params.append("limit", limit)
        const qs = params.toString()
        const endpoint = qs ? `${Endpoints.ADMIN_REFUNDS}?${qs}` : Endpoints.ADMIN_REFUNDS

        fetchData(endpoint)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false)
                if (res?.code === 200) {
                    setRows(res.data?.rows || [])
                    setTotalRows(res.data?.total_rows || 0)
                    setTotalPages(res.data?.total_pages || 0)
                } else {
                    Notify(res?.message || "Failed to load refunds", ERROR)
                }
            })
            .catch(() => {
                setIsLoading(false)
            })
    }

    return {
        isLoading,
        rows,
        totalRows,
        totalPages,
        loadRefunds,
    }
}

export default useRefunds
